var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwaitingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.998,
    height: 14.996,
    viewBox: "0 0 14.998 14.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M20250.248-17484.229a7.508,7.508,0,0,1-7.5-7.5,7.508,7.508,0,0,1,7.5-7.5,7.506,7.506,0,0,1,7.5,7.5A7.506,7.506,0,0,1,20250.248-17484.229Zm-2.965-7.91a1,1,0,0,0-1,1,1,1,0,0,0,1,1h3.234a1,1,0,0,0,1-1v-4.377a1,1,0,0,0-1-1,1,1,0,0,0-1,1v3.375Z",
    transform: "translate(-20242.748 17499.225)",
    fill: "#6b6a77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwaitingIcon);
export default __webpack_public_path__ + "static/media/awaiting_icon.4e08dc15a15c1e00dc72254b75cdf5ab.svg";
export { ForwardRef as ReactComponent };